/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
  created_on: ['created_on:gte', 'created_on:lte'],
  expected_started_on: ['expected_started_on:gte', 'expected_started_on:lte'],
  actual_started_on: ['actual_started_on:gte', 'actual_started_on:lte'],
  vehicle_id: 'vehicle.id:in',
  driver_user_id: 'driver_user.id:in',
  user_group_id: 'user_group.id:in',
}

export default parseFilterDataMapping
